import { useCallback, useEffect, useState } from "react";
import { eventPopupExpiresAt, eventPopupSessionKey } from "@/constants/nossaData";
import { hasSessionCookie, setSessionCookie } from "@/utils/sessionCookie";

function shouldShowEventPopup() {
  return Date.now() < eventPopupExpiresAt && !hasSessionCookie(eventPopupSessionKey);
}

export function useEventPopup() {
  const [showEventPopup, setShowEventPopup] = useState(false);

  useEffect(() => {
    setShowEventPopup(shouldShowEventPopup());
  }, []);

  const closeEventPopup = useCallback(() => {
    setSessionCookie(eventPopupSessionKey);
    setShowEventPopup(false);
  }, []);

  return { showEventPopup, closeEventPopup };
}